var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 42C36.836 42 44 35.732 44 28C44 20.268 36.836 14 28 14C19.164 14 12 20.268 12 28C12 31.52 13.486 34.74 15.94 37.2C15.746 39.232 15.106 41.46 14.398 43.132C14.24 43.504 14.546 43.92 14.944 43.856C19.456 43.116 22.138 41.98 23.304 41.388C24.8358 41.7966 26.4146 42.0023 28 42Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8337 23.8334C33.8337 22.9167 33.0837 22.1667 32.167 22.1667H30.5003C30.042 22.1667 29.667 22.5417 29.667 23C29.667 23.4584 30.042 23.8334 30.5003 23.8334H32.167V26.0417L29.267 29.6667H26.3337V26.3334C26.3337 25.875 25.9587 25.5 25.5003 25.5H23.0003C21.1587 25.5 19.667 26.9917 19.667 28.8334V30.5C19.667 30.9584 20.042 31.3334 20.5003 31.3334H21.3337C21.3337 32.7167 22.4503 33.8334 23.8337 33.8334C25.217 33.8334 26.3337 32.7167 26.3337 31.3334H29.267C29.7753 31.3334 30.2503 31.1 30.567 30.7084L33.467 27.0834C33.7087 26.7834 33.8337 26.4167 33.8337 26.0417V23.8334ZM23.8337 32.1667C23.3753 32.1667 23.0003 31.7917 23.0003 31.3334H24.667C24.667 31.7917 24.292 32.1667 23.8337 32.1667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0003 23H25.5003C25.9587 23 26.3337 23.375 26.3337 23.8333C26.3337 24.2917 25.9587 24.6667 25.5003 24.6667H23.0003C22.542 24.6667 22.167 24.2917 22.167 23.8333C22.167 23.375 22.542 23 23.0003 23ZM33.8337 28.8333C32.4503 28.8333 31.3337 29.95 31.3337 31.3333C31.3337 32.7167 32.4503 33.8333 33.8337 33.8333C35.217 33.8333 36.3337 32.7167 36.3337 31.3333C36.3337 29.95 35.217 28.8333 33.8337 28.8333ZM33.8337 32.1667C33.3753 32.1667 33.0003 31.7917 33.0003 31.3333C33.0003 30.875 33.3753 30.5 33.8337 30.5C34.292 30.5 34.667 30.875 34.667 31.3333C34.667 31.7917 34.292 32.1667 33.8337 32.1667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessage);
export default __webpack_public_path__ + "static/media/chatMessage.3afe4baa64a385800665b57c1b8a11fc.svg";
export { ForwardRef as ReactComponent };